import React, { createContext, useContext, useState, useEffect } from 'react';
import { signInWithGoogle, initiateKakaoLogin, logout, onAuthStateChange } from '../services/supabaseAuthService';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  function loginWithGoogle() {
    return signInWithGoogle();
  }

  function loginWithKakao() {
    // 카카오 로그인 페이지로 리다이렉트
    initiateKakaoLogin();
  }

  async function handleLogout() {
    try {
      await logout(); // Supabase 로그아웃 함수 호출
    } catch (error) {
      console.error('로그아웃 중 오류 발생:', error);
      throw error;
    }
  }

  useEffect(() => {
    const { data: { subscription } } = onAuthStateChange(user => {
      setCurrentUser(user);
      setLoading(false);
    });

    return () => subscription.unsubscribe();
  }, []);

  const value = {
    currentUser,
    loginWithGoogle,
    loginWithKakao,
    logout: handleLogout
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
} 